<template>
    <div
        class="timer-top-banner__inner"
        :class="{
            'timer-top-banner__inner--closed': isRegistrationClosed,
            'timer-top-banner__inner--soon': !endsTonight,
        }"
        ref="inner">
        <p class="timer-top-banner__title" @click.prevent="scrollToPaymentBlock" v-if="isRegistrationOpened">
            Registration Closes&nbsp;In…
        </p>
        <top-banner-title
            :percentage="percentage"
            :timerEndtime="timerEndtime"
            :top-bar-timer-force-ends-soon="topBarTimerForceEndsSoon"
            :titles="bannerTitles"
            v-else>
        </top-banner-title>

        <open-checkout-popup v-if="defaultPaymentMethod === 'null' && salesButtonSeen">
            <div class="timer-top-banner__timer">
                <top-banner-timer
                    :timerEndtime="timerEndtime"
                    :top-bar-timer-force-ends-soon="topBarTimerForceEndsSoon">
                </top-banner-timer>
            </div>
        </open-checkout-popup>

        <div class="timer-top-banner__timer" @click="scrollToPaymentBlock" v-else>
            <top-banner-timer :timerEndtime="timerEndtime" :top-bar-timer-force-ends-soon="topBarTimerForceEndsSoon">
            </top-banner-timer>
        </div>

        <div @click="hideTimerBanner" class="timer-top-banner__close">&times;</div>
    </div>
</template>

<script>
import TopBannerTimer from './top_banner/TopBannerTimer.vue';
import TopBannerTitle from './top_banner/TopBannerTitle.vue';
import { fixedTopBarMixin } from '../mixins/fixedTopBarMixin';
import { iosview } from '../iosview';
import { mapState } from 'vuex';
import { setTimerMixin } from '../mixins/setTimerMixin';

export default {
    mixins: [fixedTopBarMixin, setTimerMixin],
    components: {
        TopBannerTimer,
        TopBannerTitle,
    },
    props: {
        percentage: {},
        timerEndtime: {},
        topBarTimerForceEndsSoon: {},
        bannerTitles: {},
        registrationCloses: {},
    },
    data: function () {
        return {
            buttonClassObject: {
                'sales-button-active': false,
                transition: false,
            },
            timerVisible: true,
            timerTopBar: true,
            noThanksLinkElement: null,
        };
    },
    computed: {
        ...mapState(['isUpsell']),
        isRegistrationOpened() {
            return this.registrationCloses === 'open';
        },
        isRegistrationClosed() {
            return this.registrationCloses === 'closed';
        },
    },
    watch: {
        salesButtonSeen: function (value) {
            if (value && this.isIosView) {
                iosview.salesButtonSeen();
            }
        },
    },
    mounted() {
        if (!this.isIosView) {
            return;
        }
        // harcoded time query param to test the timerEndtime message handler - requested by iOS team to
        // TODO remove this once testing is done
        const harcodedTimerEndTime = new URLSearchParams(window.location.search).get('timerEndtime');
        if (harcodedTimerEndTime) {
            iosview.timerEndtime(harcodedTimerEndTime);
        } else {
            let countDownTime;
            const now = new Date();
            if (this.timerEndtime === 'local-midnight') {
                countDownTime = new Date();
                countDownTime.setHours(24, 0, 0, 0);
            } else {
                countDownTime = new Date(Number(this.timerEndtime));
            }
            iosview.timerEndtime(Math.round((countDownTime.getTime() - now.getTime()) / 1000));
        }
        iosview.discountPercentage(this.percentage);
        // psh
        if (window.App.sessionId) {
            iosview.paymentSessionId(window.App.sessionId);
        }
        // skip button click listener
        this.$nextTick(() => {
            if (!this.noThanksLinkElement && this.isUpsell) {
                this.noThanksLinkElement = document.querySelector('.no_thanks_btn');
                document.addEventListener('click', (e) => {
                    if (e.target.matches('.no_thanks_btn')) {
                        iosview.skipButtonClicked();
                    }
                });
            }
        });
    },
};
</script>
